<template>
    <div class="c-modal-wrapper c-gray-back">
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>        
      <!-- Application Header -->
      <!-- <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
            </div>            
            <div class="c-modal-info-title"><b>Rezervacije title</b></div>
          </div>
        </div>
      </header> -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>      
      <!-- Body content -->
      <div class="c-modal-body c-to-full-bottom c-has-skewed-background">
        <div class="c-responsive-container">
          <div v-if="eventBasicInfo">
            <!-- Basic info of Event -->
            <div class="c-event-details-block">
              <div class="c-has-event-title"><b>{{eventBasicInfo.eventName}}</b></div>
              <div class="c-has-small-details">
                <span v-if="eventBasicInfo.eventDate">{{returnEventDate_fullDate(eventBasicInfo)}}</span>
                <span v-if="eventBasicInfo.eventVenue">- {{returnEventVenue_type(eventBasicInfo)}}</span>
                <span v-if="eventBasicInfo.ticketPrice">- Ulaz: {{eventBasicInfo.ticketPrice}} {{returnCurrencyType(eventBasicInfo)}}</span>
              </div>
            </div>
            <!-- Section Title -->
            <div class="c-event-tables-title-box">Lista rezervacija za ovaj dogadjaj</div>
            <!-- List of all tables for event -->
            <transition name="fade" mode="out-in">
              <div v-if="isLoading.length == 0">
                <ul class="c-items-list" v-if="listOfReservationsForEvent">
                  <li class="c-single-event-reservation" 
                  v-for="(singleReservationItem, itemIndex) in listOfReservationsForEvent"
                  v-bind:class="returnTableCheckinClass(singleReservationItem)"
                  >
                    <table class="c-content-as-table">
                      <tbody>
                        <tr>
                          <!-- Date -->
                          <td class="c-has-table-number">
                              <!-- Table number -->
                              <span v-if="singleReservationItem.tableShortName && singleReservationItem.tableNumber"><b>{{singleReservationItem.tableShortName}}{{singleReservationItem.tableNumber}}</b></span>
                              <span v-else>Err</span>
                          </td>
                          <!-- Text content -->
                          <td class="c-has-guest-name">
                            <div v-if="singleReservationItem.guestFirstName || singleReservationItem.guestLastName || singleReservationItem.guestNickname">
                              <span v-if="singleReservationItem.guestFirstName"><b>{{singleReservationItem.guestFirstName}}</b></span>
                              <span v-if="singleReservationItem.guestLastName"><b>{{singleReservationItem.guestLastName}}</b></span>
                              <span v-if="singleReservationItem.guestNickname"><b>{{singleReservationItem.guestNickname}}</b></span>                        
                            </div>
                            <div v-else>Empty</div>
                          </td>
                          <!-- Action buttons -->
                        </tr>
                      </tbody>
                    </table>
                    <!-- Action buttons -->
                    <div class="c-has-buttons">
                      <button class="c-btn c-btn-action-on-white" v-on:click="openReservationDetails(singleReservationItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      <!-- <div v-if="calculateIfTableIsLocked(singleReservationItem)">
                        <button class="c-btn c-btn-action-on-white" v-on:click="checkLockTableStatus(singleReservationItem)"><i class="fa fa-lock c-ux-color-danger" aria-hidden="true"></i></button>
                        <button class="c-btn c-btn-action-on-white" v-if="calculateUserEditPermision(singleReservationItem)" v-on:click="openReservationDetails(singleReservationItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      </div>
                      <div v-else>
                        <button class="c-btn c-btn-action-on-white" v-on:click="toggleExpandReservationButtonOptions(singleReservationItem.uid)"><i class="fa fa-bars" aria-hidden="true"></i></button>
                        <button class="c-btn c-btn-action-on-white" v-on:click="openReservationDetails(singleReservationItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      </div> -->
                    </div>
                    <!-- Expanded buttons -->
                    <!-- <transition name="slide-left" mode="out-in">
                      <div class="c-expanded-button-options" v-if="expandedOptionsIndex == singleReservationItem.uid">
                        <div class="c-has-txt"><span>Dodatne opcije</span></div>
                        <div class="c-has-buttons">
                          <button class="c-btn c-btn-action-on-white" v-on:click="openLockTable(singleReservationItem)"><i class="fa fa-lock" aria-hidden="true"></i><span class="c-has-title">Zaključaj</span></button>
                          <button class="c-btn c-btn-action-on-white" v-on:click="openSwapReservations(singleReservationItem)"><i class="fa fa-retweet" aria-hidden="true"></i><span class="c-has-title">Zameni</span></button>
                          <button v-if="singleReservationItem.guestFirstName || singleReservationItem.guestLastName || singleReservationItem.guestNickname" 
                            class="c-btn c-btn-action-on-white" v-on:click="openCheckinStatus(singleReservationItem)">
                            <i class="fa fa-bell" aria-hidden="true"></i>
                            <span class="c-has-title">Čekiraj</span>
                          </button>
                          <button class="c-btn c-btn-action-on-white" v-on:click="toggleExpandReservationButtonOptions(singleReservationItem.uid)"><i class="fa fa-times" aria-hidden="true"></i></button>
                        </div>
                      </div>
                    </transition> -->
                  </li>
                </ul>
                <div v-else><b>Nothing to show</b></div>
              </div>
            </transition>
          </div>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
      <!-- Modal Templates -->
      <transition name="slide-up" mode="out-in">
        <component 
          v-if="modalComponent.isVisible" 
          v-bind:is="modalComponent.activeModalComponent"
          v-bind:input-modal-data = "modalComponent.dataForModal"
        ></component>
      </transition>
    </div>
</template>

<script>

import router from '@/router/index'
import EventBus from '@/EventBus'
import ModalSingleArchivedReservation from '@/components/eventsArchive/ModalSingleArchivedReservation'
import moment from 'moment'
import {firebaseDB} from '@/firebase';
import OverlayLoader from "@/components/helpers/OverlayLoader";
export default {
  name: 'ModalArchivedEventReservations',
  props: ['inputModalData'],
  components: {
    ModalSingleArchivedReservation: ModalSingleArchivedReservation,
    OverlayLoader: OverlayLoader
  },    
  data () {
    return {
      msg: 'ModalArchivedEventReservations modal',
      isLoading: [1],
      currentFirebaseUser: null,
      expandedOptionsIndex: null,
      eventBasicInfo: null,
      eventReservationsList: null,
      listOfReservationsForEvent: null,
      tempListOfWaiters: null,
      tempListOfAllRegularGuests: null,
      tempListOfAllVenues: null, 
      tempListOfCurrencyUnits: null,
      // status rezervacije (waiting:1=Ceka se gost da dodje, arrived:2=Gost je dosao, notArrived:3=Gost nije dosao), koristi se da se zna da li je gost dosao ili je ispalio
      tableStatusEnums: null,
      resolve: null,
      reject: null,
      // ~ received object of event that we want to show
      eventObject: null,
      // ~ for showing modal
      modalComponent: {
        isVisible: false,
        activeModalComponent: null,
        dataForModal: null
      }      
    }
  },
  methods: {
    getAllReservationsForEvent : function (inputThisEventUid){
      //console.log('inputThisEventUid: ' + inputThisEventUid);
      var starCountRef = firebaseDB.ref('listOfAllEventsReservations/' + inputThisEventUid);
      starCountRef.on('value', function(snapshot) {
        //console.log('Read Res list SUCCESS>> ');
        //console.log('snapshot.val(): ' + JSON.stringify(snapshot.val(), null, 2));
        this.listOfReservationsForEvent = snapshot.val(); 
        setTimeout(function(){ 
          this.isLoading.pop();
        }.bind(this), 200);
      }.bind(this));
      // firebaseDB.ref().child('listOfAllEventsReservations/' + inputThisEventUid).on('value', function(snapshot){
      //   console.log('Read Res list SUCCESS>> ');
      //   console.log('snapshot.val(): ' + JSON.stringify(snapshot.val(), null, 2));
      // });      
      // firebaseDB.ref().child('listOfAllEventsReservations/' + inputThisEventUid).on('value').then(
      //   function (response) {
      //     console.log('Read Res list SUCCESS: ' + JSON.stringify(response, null, 2));
      //   }.bind(this),
      //   function (error){
      //     console.log('Read Res list ERROR: ' + JSON.stringify(error, null, 2));
      //   }.bind(this)
      // );
    },    
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      // var resultToReturn = {
      //   tempMsg: 'ModalArchivedEventReservations returns Yes'
      // }
      // this.resolve(resultToReturn);
      /*
        ====== > For each regular guest in Event reservations, save informations inside Regular Guest spending history
      */
      //if event details has info about reservations for this event object
      if (this.inputModalData && this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedEventObject && this.inputModalData.dataForModal.selectedEventObject.eventReservationsKey){
        this.isLoading.push(1);
        var tmpEventsReservationsKey = this.inputModalData.dataForModal.selectedEventObject.eventReservationsKey;
        // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        //console.log('fired once start');
        var starCountRef = firebaseDB.ref('listOfAllEventsReservations/' + tmpEventsReservationsKey).once('value').then(
          function(snapshot) {
            // console.log('##############');
            // console.log('##############');
            // console.log('##############');
            // console.log('snapshot received start');
            // The Promise was "fulfilled" (it succeeded).
            /*
              ====== > Go through each Reservation with Regular Guest and save info into Regular Guest spending history
            */            
            //console.log('allReservationsDisplay: ' + JSON.stringify(snapshot.val(), null, 2) );
            var listOfAllReservationsForEvent = snapshot.val();
            var eventKey = this.inputModalData.dataForModal.selectedEventObject.eventUid;
            var tmpSelectedEventObject = JSON.parse(JSON.stringify(this.inputModalData.dataForModal.selectedEventObject));
            //var listOfAllReservationsForEvent = JSON.parse(JSON.stringify(snapshot.val()));
            for (var key  in listOfAllReservationsForEvent) {
              // CHECK IF WE RESERVATION HAS REGULAR GUEST SAVED or just plain non-regular guest
              if (listOfAllReservationsForEvent.hasOwnProperty(key) && listOfAllReservationsForEvent[key] && listOfAllReservationsForEvent[key].regularGuestKey && listOfAllReservationsForEvent[key].regularGuestKey != null && listOfAllReservationsForEvent[key].regularGuestKey != 'empty'){
                // IF WE HAVE REGULAR GUEST AT SOME TABLE/RESERVATION, we must save info from that reservation tu Regular Guest Spending history
                // console.log('!!!!!!!!!!!! listOfAllReservationsForEvent[key]: ' + listOfAllReservationsForEvent[key]);
                // console.log('!!!!!!!!!!!! listOfAllReservationsForEvent[key] objecty: ' + JSON.stringify(listOfAllReservationsForEvent[key], null, 2) );
                // console.log('!!!!!!!!!!!! key: ' + key);
                /* 
                  ===== > If we found regular guest that has reservation, then we must also save that info inside each guest history
                */                
                var singleRegularGuestKey = listOfAllReservationsForEvent[key].regularGuestKey;
                //console.log('!!!!!!!!!!!! singleRegularGuestKey: ' + singleRegularGuestKey);
                //console.log('!!!!!!!!!!!! tmpSelectedEventObject objecty: ' + JSON.stringify(tmpSelectedEventObject, null, 2) );
                // regular-guest-uid-key, event-uid-key, entire-event-info-object, table-info-object
                this.updateRegularGuestSpendHistory(singleRegularGuestKey, eventKey, tmpSelectedEventObject, listOfAllReservationsForEvent[key]);
              }
            }
            // for (var key in listOfAllReservationsForEvent) {
            //   if (listOfAllReservationsForEvent.hasOwnProperty(key) && key == 'eventReservationsKey' && key != null && key != 'empty') {
            //     console.log('!!!!!!!!!!!! regular guest res: ' + listOfAllReservationsForEvent[key]);
            //   }
            // }
            /*
              ====== > Close modal and save Event Details changes
            */
            var resultToReturn = {
              tempMsg: 'ModalArchivedEventReservations returns Yes'
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function(error) {
            // The Promise was rejected.
            console.log('allReservationsDisplay FAILDED: ' + error );
            //console.error(error);
            this.reject();
          }.bind(this)
        );
      // var starCountRef = firebaseDB.ref('listOfAllEventsReservations/' + inputThisEventUid);
      // starCountRef.on('value', function(snapshot) {
      //   console.log('Read Res list SUCCESS>> ');
      //   console.log('snapshot.val(): ' + JSON.stringify(snapshot.val(), null, 2));
      //   this.listOfReservationsForEvent = snapshot.val(); 
      //   setTimeout(function(){ 
      //     this.isLoading.pop();
      //   }.bind(this), 200);
      // }.bind(this));        
      }      
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    },
    /* #region Show Single Reservation Details Modal */
    /////
    updateRegularGuestSpendHistory: function (inputRegularGuestKey, inputEventKey, inputSelectedEventObject, inputTableInfoObject) {
      //console.log('updateRegularGuestSpendHistory>>, inputTableInfoObject: ' + JSON.stringify(inputTableInfoObject, null, 2));
      /*
        ==== Now we must update Regular Guest history for this event
        */      
      firebaseDB.ref().child('/listOfRegularGuestsHistory/' + inputRegularGuestKey + '/' + inputEventKey ).update({
        //Event Firebase UID
        eventUid: (inputSelectedEventObject && inputSelectedEventObject.eventUid) ? inputSelectedEventObject.eventUid : null,
        eventDate: (inputSelectedEventObject && inputSelectedEventObject.eventDate) ? inputSelectedEventObject.eventDate : null,
        eventName: (inputSelectedEventObject && inputSelectedEventObject.eventName) ? inputSelectedEventObject.eventName : null,
        eventReservationsKey: (inputSelectedEventObject && inputSelectedEventObject.eventReservationsKey) ? inputSelectedEventObject.eventReservationsKey : null,
        // Regular Guest spending info
        // tableViewUid: (this.selectedTableObject && this.selectedTableObject['.key']) ? this.selectedTableObject['.key'] : null,
        // tableViewName: (this.selectedTableObject && this.selectedTableObject.tableShortName && this.selectedTableObject.tableNumber) ? (this.selectedTableObject.tableShortName + this.selectedTableObject.tableNumber) : null,        
        tableViewUid: (inputTableInfoObject && inputTableInfoObject.uid) ? inputTableInfoObject.uid : null,
        tableViewName: (inputTableInfoObject && inputTableInfoObject.tableShortName) ? inputTableInfoObject.tableShortName : null,
        tableBill: (inputTableInfoObject && inputTableInfoObject.tableBill) ? inputTableInfoObject.tableBill : null,
        tableWaiterUid: (inputTableInfoObject && inputTableInfoObject.tableWaiterUid) ? inputTableInfoObject.tableWaiterUid : null,
        tableOrderedDrinks: (inputTableInfoObject && inputTableInfoObject.tableOrderedDrinks) ? inputTableInfoObject.tableOrderedDrinks : null,
        tableComplimentaryDrinks: (inputTableInfoObject && inputTableInfoObject.tableComplimentaryDrinks) ? inputTableInfoObject.tableComplimentaryDrinks : null
      }).then(
        function (response) {
          //console.log('= Firebase Regular Guest UPDATE succ: ' + JSON.stringify(response, null, 2));
          var resultToReturn = {
            tempMsg: 'ModalArchivedEventReservations returns Yes'
          }
          this.resolve(resultToReturn);
        }.bind(this),
        function (error){
          console.log('Firebase Regular Guest UPDATE ERROR: ' + JSON.stringify(error, null, 2));
        }.bind(this)
      );
    },
    // ~ when user wants to change Reservations for some event
    openReservationDetails: function (inputReservationItem) {
      //console.log('open single reservatio details modal');
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_SingleReservationDetails(inputReservationItem).then(
        function(response){
          //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject){
          console.log('Modal returned reject');
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_SingleReservationDetails: function (inputReservationItem) {
      return new Promise ((resolve, reject)=>{
        this.modalComponent.activeModalComponent = ModalSingleArchivedReservation;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
            headerTitle: 'Event Reservations Title',
            dataForModal: {
              selectedReservationItem: inputReservationItem,
              listOfAllRegularGuests: this.tempListOfAllRegularGuests,
              listOfAllWaiters: this.tempListOfWaiters,
              eventUidKey: this.eventBasicInfo.eventUid,
              eventReservationsKey: this.eventBasicInfo.eventReservationsKey
            },
            resolve: resolve,
            reject: reject
        }
      });
    },    
    /* #endregion Show Single Reservation Details Modal */
    closeModal: function (){
      this.modalComponent.isVisible = false;
      this.modalComponent.activeModalComponent = null;
      this.modalComponent.dataForModal = null;
      this.expandedOptionsIndex = null;
    },
    returnEventDayOfWeek: function (inputEventObject) {
      var returnValue = 'Nedefinisan'
      if (inputEventObject && inputEventObject.eventDate){
        returnValue = moment(inputEventObject.eventDate).format("dddd");
      }
      return returnValue;
    },
    returnEventDate_fullDate: function (inputEventObject) {
      var returnDate = 'Nedefinisan'
      if (inputEventObject && inputEventObject.eventDate){
        returnDate = moment(inputEventObject.eventDate).format('DD. MMMM YYYY.');
      }
      //
      return returnDate;
    },
    returnCurrencyType: function (inputEventObject) {
      var returnValue = '--';
      if (inputEventObject && inputEventObject.ticketPriceCurrency && this.tempListOfCurrencyUnits){
        for (var key in this.tempListOfCurrencyUnits) {
          if (this.tempListOfCurrencyUnits.hasOwnProperty(key)) {
            if (key == inputEventObject.ticketPriceCurrency && this.tempListOfCurrencyUnits[key].title){
              //console.log('name is this: ' + this.tempListOfAllVenues[key].name);
              returnValue = this.tempListOfCurrencyUnits[key].title;
            }
          }
        }     
      }
      return returnValue;
    },
    returnEventVenue_type: function (inputEventObject) {
      var returnValue = 'Nedefinisan';
      if (inputEventObject && inputEventObject.eventVenue){
        //console.log('this.tempListOfAllVenues: ' + JSON.stringify(this.tempListOfAllVenues, null, 2) );
        for (var key in this.tempListOfAllVenues) {
          if (this.tempListOfAllVenues.hasOwnProperty(key)) {
            if (key == inputEventObject.eventVenue && this.tempListOfAllVenues[key].name){
              //console.log('name is this: ' + this.tempListOfAllVenues[key].name);
              returnValue = this.tempListOfAllVenues[key].name;
            }
          }
        }
      }
      return returnValue;
    },
    ///
    returnTableCheckinClass: function (inputTableObject) {
      var returnClass = "";
      if (inputTableObject && (inputTableObject.guestFirstName || inputTableObject.guestLastName || inputTableObject.guestNickname)){        
        returnClass = 'c-status-is-waiting';
        if (inputTableObject.tableCheckedInStatus && (inputTableObject.tableCheckedInStatus==this.tableStatusEnums.notArrived)){
          returnClass = 'c-status-is-canceled';
        }
        if (inputTableObject.tableCheckedInStatus && (inputTableObject.tableCheckedInStatus==this.tableStatusEnums.arrived)){
          returnClass = 'c-status-is-checked';
        }        
      }
      //
      return returnClass;
    },
    //
    calculateIfTableIsLocked: function (inputTableObject){
      var returnValue = false;
      if (inputTableObject && inputTableObject.tableLocked && inputTableObject.tableLocked.lockedByUserUid){
        returnValue = true;
      }
      return returnValue;
    },
    //
    checkLockTableStatus: function (inputTableObject){
      if (this.currentFirebaseUser && this.currentFirebaseUser.currentUser && this.currentFirebaseUser.currentUser.uid && inputTableObject.tableLocked.lockedByUserUid && inputTableObject.tableLocked.lockedByUserUid == this.currentFirebaseUser.currentUser.uid){
        this.openLockTable(inputTableObject);
      }else{
        this.showWhoLockedTable(inputTableObject);
      }
    }  
  },
  created () {
    //console.log('~ created- ModalArchivedEventReservations component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedEventObject){
        this.eventBasicInfo = this.inputModalData.dataForModal.selectedEventObject;
        this.getAllReservationsForEvent(this.eventBasicInfo.eventReservationsKey);
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfRegularGuests){
        this.tempListOfAllRegularGuests = this.inputModalData.dataForModal.listOfRegularGuests;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfVenueTypes){
        this.tempListOfAllVenues = this.inputModalData.dataForModal.listOfVenueTypes;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfCurrencyUnits){
        this.tempListOfCurrencyUnits = this.inputModalData.dataForModal.listOfCurrencyUnits;
      }  
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfWaiters){
        this.tempListOfWaiters = this.inputModalData.dataForModal.listOfWaiters;
      }        
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.tableStatusEnums){
        this.tableStatusEnums = this.inputModalData.dataForModal.tableStatusEnums;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.currentFirebaseUser){
        this.currentFirebaseUser = this.inputModalData.dataForModal.currentFirebaseUser;
        //console.log('this.currentFirebaseUser: ' + JSON.stringify(this.currentFirebaseUser, null, 2) );
      }          
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
      //
      //this.getWantedEventData();
    }
  },
  mounted () {
    //console.log('~ mounted - ModalArchivedEventReservations component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalArchivedEventReservations component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/eventsArchive/ModalArchivedEventReservations.vue